import React from 'react'
import { BsFillSkipBackwardCircleFill } from 'react-icons/bs'
import {
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCalculator,
  FaMoneyBill,
  FaMonero,
  FaCheckCircle,
} from 'react-icons/fa'
import { FiCreditCard } from 'react-icons/fi'

function getPaymentMethodIcon(method) {
  switch (method) {
    case 'visa':
      return <FaCcVisa className="icon-primary" />
    case 'master':
      return <FaCcMastercard className="icon-primary" />
    case 'amex':
      return <FaCcAmex className="icon-primary" />
    case 'account_money':
      return <FaMoneyBill className="icon-primary" />
    case 'pix':
      return <FaMonero className="icon-primary" />
    case 'elo':
      return <FaCheckCircle className="icon-primary" />
    case 'consumer_credits':
      return <BsFillSkipBackwardCircleFill className="icon-primary" />
    default:
      return <FiCreditCard className="icon-primary" />
  }
}

export default getPaymentMethodIcon
